import axios from "axios";
import * as d3 from "d3";
import {colonAnnotation, inrFormatter, make_y_gridlines, make_x_gridlines, numberFormat, colourScheme} from '../functions'

export default function (chart, divId, vizName, filterParam,checkbox,gridflag) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //var tempVar = chart.tempVar
    console.log("abcd1",chart);
    console.log("abcd2",divId);
    console.log("abcd3",vizName);
    console.log("abcd4",filterParam);
    console.log("abcd5",gridflag);
    console.log("abcd6",checkbox);
    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    // Scales. Note the inverted domain fo y-scale: bigger is up!
    var x1Scale = d3.scaleLinear().range([0, chart.width]);
    var y1Scale = d3.scaleBand().rangeRound([chart.height, 0]).padding(0.002)
    var left1 = 4
    var x1AxisLabel = d3.axisBottom(x1Scale)
    var y1AxisLabel = d3.axisLeft(y1Scale)


    axios.post(url, filterParam).then(res => {
        let data = res.data;
        // data.sort((a, b) => b.metric1 - a.metric1);
        console.log("dataa", data);
        // Data is nested by country
        var categories = d3.nest()
            .key(function (d) {
                return d.dim2_name;
            })
            //  .sortKeys(d3.ascending)
            .entries(data);
        // for (let i = 0; i < data.map((d)=>{d.dim4_name}); i++) {
        //     let color = d.dim4_name;
        //     console.log(`Color ${i + 1}: ${color}`);
        // }
        console.log("hello",chart.colourscheme1);
        console.log("hello",chart.colourscheme1[0]);
        console.log("hello",chart.colourscheme1[1]);
        gridflag===true
        console.log(chart.colorscheme1)
        if (checkbox == true) {

            y1Scale.domain(data.map(function (d) {
                console.log("nood", d.dim3_name)
                return d.dim3_name;
            }))

            x1Scale.domain([0, d3.max(data.map((d) => {
                return d.metric1
            }))]);

            svg = d3.select(divId)
            svg.selectAll("*").remove();

            d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
            var div3 = d3.select(divId).append('div').attr('class', 'tooltip')
                .attr('style', 'position: absolute; opacity: 0;')
            // Add an SVG element for each country, with the desired dimensions and margin.
            svg = d3.select(divId).selectAll("svg")
                .data(categories)
                .enter()
                .append("svg")
                .attr("width", function (d, i) {
                    return categories[i] == categories[0] ? chart.width + chart.margin.left + chart.margin.right : chart.width + left1 + chart.margin.right
                })
                .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
                //.call(responsivefy)
                .append("g")
                .attr("transform", function (d, i) {
                    return categories[i] == categories[0] ? "translate(" + chart.margin.left + "," + chart.margin.top + ")" : "translate(" + left1 + "," + chart.margin.top + ")"
                })

            //   var myColor1 = colourScheme(chart.colourscheme1);
            console.log("myColor1", chart.colourscheme1);
            var metric1ColorScale = d3.scaleLinear().domain([0, d3.max(data.map((d) => {
                return d.metric1
            }))]).range(["#eff3ff", "#08519c"])
            var metric2ColorScale = d3.scaleLinear().domain([0, d3.max(data.map((d) => {
                return d.metric1
            }))]).range(["#fed976", "#bd0026"])

            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + chart.height + ")")
                .call(x1AxisLabel.tickFormat(numberFormat).ticks(5))
                .style('fill', '#E8E8E8')
                .selectAll('text') //addidng text on x-axis
                .style('font-size', axisLabelFontSize)
                .style('text-anchor', 'end')
                .attr('dx', '-.1em')
                .attr('transform', 'rotate(-50)');

            //adding axis labels
            svg.append("text")
                .attr("transform",
                    "translate(" + (chart.width / 2) + " ," +
                    (chart.height + chart.margin.top + 60) + ")")
                .style("text-anchor", "middle")
                .attr("font-size", fontSize)
                .attr("fill", fontColor)
                .text((d) => {
                    return d.key
                })
            svg.append("text")
                .attr("transform",
                    "translate(" + (chart.width / 2) + " ," +
                    (chart.margin.top - 40) + ")") // Adjust the y-coordinate here
                .style("text-anchor", "middle")
                .attr("font-size", fontSize)
                .attr("fill", fontColor)
                .text((d) => {
                    return d.key;
                });


            //adding axis labels
            svg.append("g")
                .attr("class", "y axis")
                .call(y1AxisLabel)
                .attr("transform", "translate(" + x1Scale(d3.min(data, (d) => {
                    return d.metric1
                })) + ",0)")
                .call(d3.axisLeft(y1Scale))
                .selectAll('text')
                .style('font-size', axisLabelFontSize)
                .style('text-anchor', 'end')
                .attr('dx', "-0.4em")
                .attr("dy", "-0.35em")
                .text(function (d) {
                    return d;
                })
            svg.selectAll('.y.axis .tick line')
                .attr('transform', `translate(0, ${-y1Scale.bandwidth() / 4.2})`)


            svg.append('text')
                .attr('transform', 'rotate(-90)')
                .attr('y', 0 - chart.margin.left)
                .attr('x', 0 - (chart.height / 2) + 50)
                .attr("dy", ".71em")
                .style("text-anchor", "end")
                .style('fill', fontColor)
                .style('font-size', fontSize)
                .text(chart.y1AxisDisplayName)


            if (gridflag === true) {
                // add the X gridlines
                svg.append("g")
                    .attr("class", "grid")
                    .attr("transform", "translate(0," + chart.height + ")")
                    .call(make_x_gridlines(x1Scale)
                        .tickSize(-chart.height)
                        .tickFormat(""))
                    .style("stroke-width", 0.1)

                // add the y gridlines
                svg.append("g")
                    .attr("class", "grid")
                    //.attr("transform", "translate(0," + chart.margin-20 + ")")
                    .call(make_y_gridlines(y1Scale)
                        .tickSize(-chart.width)
                        .tickFormat(""))
                    .style("stroke-width", 0.1);
            }


            // Accessing nested data: https://groups.google.com/forum/#!topic/d3-js/kummm9mS4EA
            // data(function(d) {return d.values;})
            // this will dereference the values for nested data for each group
            svg.selectAll(".barmpc")
                .data(function (d) {
                    return d.values.sort((a, b) => b.metric1 - a.metric1);
                })
                .enter()
                .append("rect")
                .attr("class", "barmpc")
                .attr("d", function (d) {
                    return console.log("keyss", d.key)
                })
                .attr("y", function (d) {
                    return y1Scale(d.dim3_name);
                })
                .attr("width", function (d) {
                    return x1Scale(d.metric1);
                })
                .attr("d", function (d) {
                    return console.log("va", d.values)
                })
                .attr("height", y1Scale.bandwidth() / 1.7)
                .attr("fill", function (d) {
                    console.log("dim2_name:", d.dim2_name);
                    console.log("dim4_name:", d.dim4_name);

                    return d.dim2_name == chart.x1MetricTooltip || d.dim2_name == chart.x2MetricTooltip
                        ? metric1ColorScale(d.metric1)
                        : metric2ColorScale(d.metric1);
                })

                .on("mousemove", function (d) {
                    console.log(d3.event, d)
                    div3.transition()
                        .duration(200)
                        .style("opacity", .9);
                    div3.html(
                        chart.y1AxisDisplayName + colonAnnotation + d.dim3_name + "<br/>"
                        + d.dim2_name + colonAnnotation + inrFormatter(d.metric1))
                        .style("left", d3.event.clientX - divId.getBoundingClientRect().left + "px")
                        .style("top", d3.event.clientY - divId.getBoundingClientRect().top + "px");
                })
                .on("mouseout", function () {
                    div.transition().style("opacity", 0)
                })
            svg.selectAll(".barmpc-text")
                .data(function (d) {
                    return d.values;
                })
                .enter()
                .append("text")
                .attr("class", "barmpc-text")
                .text(function (d) {
                    // Add the text content here
                    return numberFormat(d.metric1); // Adjust this based on your data
                })
                .attr("x", function (d) {
                    return x1Scale(d.metric1) + 5; // Adjust the positioning as needed
                })
                .attr("y", function (d) {
                    return y1Scale(d.dim3_name) + y1Scale.bandwidth() / 2; // Adjust the positioning as needed
                })
                .style("font-size", "10px") // Set the font size as needed
                .style("fill", "black"); // Set the text color as needed

            /*.on('mouseover', y1tip.show)
           .on('mouseout', y1tip.hide)*/
            //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding
            /*.call(y1tip);*/
        } else {
            categories.forEach(function (d) {
                d.maxNumber = d3.max(d.values, function (d) {

                    return d.metric1;
                });
            });
            // Compute the minimum and maximum year and percent across symbols.
            y1Scale.domain(data.map(function (d) {
                return d.dim3_name;
            }));

            var svg = d3.select(divId)
            svg.selectAll("*").remove();

            d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
            var div = d3.select(divId).append('div').attr('class', 'tooltip')
                .attr('style', 'position: absolute; opacity: 0;')
            // Add an SVG element for each country, with the desired dimensions and margin.
            svg = d3.select(divId).selectAll("svg")
                .data(categories)
                .enter()
                .append("svg")
                .attr("width", function (d, i) {
                    return categories[i] == categories[0] ? chart.width + chart.margin.left + chart.margin.right : chart.width + left1 + chart.margin.right
                })
                .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
                //.call(responsivefy)
                .append("g")
                .attr("transform", function (d, i) {
                    return categories[i] == categories[0] ? "translate(" + chart.margin.left + "," + chart.margin.top + ")" : "translate(" + left1 + "," + chart.margin.top + ")"
                })
                .attr("id", (d) => {
                    return d.key
                })

            categories.forEach(function (d) {
                //CSS.escape(id) - will escape special character in id/key

                var svg = d3.select("#" + CSS.escape(d.key));
                x1Scale.domain([0, d.maxNumber]);
console.log("color1",);
                var metric1ColorScale = d3.scaleSequential(colourScheme(d.values[0].dim4_name))
                    .domain([0, d.maxNumber]);
                var metric2ColorScale = d3.scaleSequential(colourScheme(d.values[1].dim4_name))
                    .domain([0, d.maxNumber]);
                var metric3ColorScale = d3.scaleSequential(colourScheme(d.values[2].dim4_name))
                    .domain([0, d.maxNumber]);
                var metric4ColorScale = d3.scaleSequential(colourScheme(d.values[3].dim4_name))
                    .domain([0, d.maxNumber]);
                svg.append("g")
                    .attr("class", "x axis")
                    .attr("transform", "translate(0," + chart.height + ")")
                    .call(x1AxisLabel.tickFormat(numberFormat).ticks(5))
                    .style('fill', '#E8E8E8')
                    .selectAll('text') //addidng text on x-axis
                    .style('font-size', axisLabelFontSize)
                    .style('text-anchor', 'end')
                    .attr('dx', '-.1em')
                    .attr('transform', 'rotate(-50)');

                //adding axis labels
                svg.append("text")
                    .attr("transform",
                        "translate(" + (chart.width / 2) + " ," +
                        (chart.height + chart.margin.top + 60) + ")")
                    .style("text-anchor", "middle")
                    .attr("font-size", fontSize)
                    .attr("fill", fontColor)
                    .text((d) => {
                        return d.key
                    });
                svg.append("text")
                    .attr("transform",
                        "translate(" + (chart.width / 2) + " ," +
                        (chart.margin.top - 40) + ")") // Adjust the y-coordinate here
                    .style("text-anchor", "middle")
                    .attr("font-size", fontSize)
                    .attr("fill", fontColor)
                    .text((d) => {
                        return d.key;
                    });

                //adding axis labels
                //adding axis labels
                svg.append("g")
                    .attr("class", "y axis")
                    .call(y1AxisLabel)
                    .attr("transform", "translate(" + (x1Scale(d3.min(data, (d) => d.metric1)) - 8) + ",0)")
                    .call(d3.axisLeft(y1Scale))
                    .selectAll('text')
                    .style('font-size', axisLabelFontSize)
                    .style('text-anchor', 'end')
                    .attr('dx', "-0.4em")
                    .attr("dy", "-0.35em")
                    .text(function (d) {
                        return d;
                    })
                svg.selectAll('.y.axis .tick line')
                    .attr('transform', `translate(0, ${-y1Scale.bandwidth() / 4.2})`)


                svg.append('text')
                    .attr('transform', 'rotate(-90)')
                    .attr('y', 0 - chart.margin.left)
                    .attr('x', 0 - (chart.height / 2) + 50)
                    .attr("dy", ".71em")
                    .style("text-anchor", "end")
                    .style('fill', fontColor)
                    .style('font-size', fontSize)
                    .text(chart.y1AxisDisplayName)

                if (gridflag === true) {
                    // add the X gridlines
                    svg.append("g")
                        .attr("class", "grid")
                        .attr("transform", "translate(0," + chart.height + ")")
                        .call(make_x_gridlines(x1Scale)
                            .tickSize(-chart.height)
                            .tickFormat(""))
                        .style("stroke-width", 0.1)

                    // add the Y gridlines
                    svg.append("g")
                        .attr("class", "grid")
                        .call(make_y_gridlines(y1Scale)
                            .tickSize(-chart.width)
                            .tickFormat(""))
                        .style("stroke-width", 0.1)
                }

                // Accessing nested data: https://groups.google.com/forum/#!topic/d3-js/kummm9mS4EA
                // data(function(d) {return d.values;})
                // this will dereference the values for nested data for each group
                svg.selectAll(".barmpc")
                    .data(function (d) {
                        return d.values;
                    })
                    .enter()
                    .append("rect")
                    .attr("class", "barmpc")
                    .attr("d", function (d) {
                        return console.log("keyss", d.key)
                    })
                    .attr("y", function (d) {
                        return y1Scale(d.dim3_name);
                    })
                    .attr("width", function (d) {
                        return x1Scale(d.metric1);
                    })
                    .attr("d", function (d) {
                        return console.log("va", d.values)
                    })
                    .attr("height", y1Scale.bandwidth() / 1.7)
                    .attr("fill", function (d) {
                        console.log("nooo", d.dim2_name);
                        console.log("bube", chart.x1MetricTooltip);
                        console.log("bnb", chart.x2MetricTooltip)
                        if (
                            d.dim2_name == chart.x1MetricTooltip
                        ) {
                            console.log("color",d.dim4_name);
                            return metric3ColorScale(d.metric1);
                        } else if (d.dim2_name == chart.y1MetricTooltip) {
                            return metric1ColorScale(d.metric1);
                        } else if (d.dim2_name == chart.x2MetricTooltip) {
                            return metric4ColorScale(d.metric1);
                        } else {
                            return metric2ColorScale(d.metric1);
                        }
                    })

                    .on("mousemove", function (d) {
                        console.log(d3.event, d)
                        div.transition()
                            .duration(200)
                            .style("opacity", .9);
                        div.html(
                            chart.y1AxisDisplayName + colonAnnotation + d.dim3_name + "<br/>"
                            + d.dim2_name + colonAnnotation + inrFormatter(d.metric1))
                            .style("left", d3.event.clientX - divId.getBoundingClientRect().left + "px")
                            .style("top", d3.event.clientY - divId.getBoundingClientRect().top + "px");
                    })
                    .on("mouseout", function () {
                        div.transition().style("opacity", 0)
                    })
                svg.selectAll(".barmpc-text")
                    .data(function (d) {
                        return d.values;
                    })
                    .enter()
                    .append("text")
                    .attr("class", "barmpc-text")
                    .text(function (d) {
                        // Add the text content here
                        return numberFormat(d.metric1) ; // Adjust this based on your data
                    })
                    .attr("x", function (d) {
                        return x1Scale(d.metric1) / 2.5; // Center the text within the rectangle
                    })
                    .attr("y", function (d) {
                        return y1Scale(d.dim3_name) + y1Scale.bandwidth() / 2; // Center the text vertically within the rectangle
                    })
                    .style("font-size", "10px") // Set the font size as needed
                    .style("fill", "black"); // Set the text color as needed
            });
        }
    })
}
